// extracted by mini-css-extract-plugin
export default {"actions":"Pagos_actions__Qz2FG","link":"Pagos_link__7OSYM","deuda":"Pagos_deuda__kdZNL"};